<template>
    <div id="policy-layout" class="col-12 col-lg-12 p-0">
        <div id="top-holder" class="col-12 col-lg-12 p-0">
            <div id="top" class="row">
                <router-link
                    to="/"                    
                >
                    <img src="https://bucket-tarserp-resources.s3-sa-east-1.amazonaws.com/images/onelogo-base.png"/>
                </router-link>
                <h3>Privacidade & Termos</h3>
            </div>
            
            <div id="menu">
                <router-link 
                    to="/policies/privacy" 
                    class="col-12 col-lg-2" 
                    tag="button"
                    v-bind:class="{ active: $route.params.policy == 'privacy' }"
                >Política de privacidade</router-link>

                <router-link to="/policies/terms" 
                    class="col-12 col-lg-2" 
                    tag="button"
                    v-bind:class="{ active: $route.params.policy == 'terms' }"
                >Termos de Serviço</router-link>
            </div>
        </div>

        <div id="policies-box" class="col-12 col-lg-12">            
            <slot />
        </div>
        
    </div>
</template>

<script>
import $ from 'jquery'

export default {
    name: 'policy-layout',
    mounted: function () {
        $(document).scrollTop(0)
    }    
}

</script>

<style lang="scss">

#policy-layout {

    margin: 0 auto;
    display: flex;
    flex-direction: column;

    #top-holder {

        flex: 1;
        background-color: #fff;        

        #top {

            text-align: left;
            margin: 30px 30px;

            img {
                height: 20px;
                margin-top: -6px;
                margin-right: 10px;        
            }

            h3 {
                line-height: 20px;
                font-weight: 400;
            }            

        }

        #menu {

            border-bottom: 1px solid rgba(130,130,130,.2);

            button {
                background-color: transparent;
                border: none;
                border-bottom: 2px solid transparent;
                outline: none;
            }

            .active {
                border-bottom: 2px solid #adb5bd;
            }
            

        }
    }

    #policies-box {
        flex: 5;
        margin: 0 auto;
        max-width: 1300px;
    }
}

.text-field-area, .text-field-holder, .text-field, .input-border, .input-border-animate {
  box-sizing: content-box;
}

</style>
